import React from 'react';
import { usePageState } from '../context/AppStateContext';
import { useMessageBox } from '../components/Common/MessageBox';
import './PlaceholderPage.css';

const InviteUsersPage = () => {
  const { showInfo, MessageBoxComponent } = useMessageBox();
  // =============================================
  // STATE PERSISTENCE (via AppStateContext)
  // =============================================
  const { state, setState } = usePageState('inviteUsers');

  // Destructure with defaults
  const { firstName = '', lastName = '', email = '', role = '' } = state;

  // Handle input changes
  const handleFirstNameChange = (e) => {
    setState({ firstName: e.target.value });
  };

  const handleLastNameChange = (e) => {
    setState({ lastName: e.target.value });
  };

  const handleEmailChange = (e) => {
    setState({ email: e.target.value });
  };

  const handleRoleChange = (e) => {
    setState({ role: e.target.value });
  };

  return (
    <div className="placeholder-page">
      <h1 className="page-title">Invite Users</h1>
      <p className="page-description">
        User invitation form with role assignment will be added here.
      </p>

      <div className="invite-placeholder">
        <div className="form-field">
          <label>First Name</label>
          <input
            type="text"
            placeholder="First name"
            value={firstName}
            onChange={handleFirstNameChange}
          />
        </div>
        <div className="form-field">
          <label>Last Name</label>
          <input
            type="text"
            placeholder="Last name"
            value={lastName}
            onChange={handleLastNameChange}
          />
        </div>
        <div className="form-field">
          <label>Email Address</label>
          <input
            type="email"
            placeholder="user@example.com"
            value={email}
            onChange={handleEmailChange}
          />
        </div>
        <div className="form-field">
          <label>Role</label>
          <select value={role} onChange={handleRoleChange}>
            <option value="">Select Role</option>
            <option value="Owner">Owner</option>
            <option value="Admin">Admin</option>
            <option value="Editor">Editor</option>
          </select>
        </div>
        <button className="action-btn" onClick={(e) => { e.preventDefault(); showInfo('Invitation functionality will be added soon!'); }}>Send Invitation</button>
      </div>
      <MessageBoxComponent />
    </div>
  );
};

export default InviteUsersPage;
